import ReactEcharts from "echarts-for-react";
import React from "react";
import {BrowserRouter as Router, Switch} from "react-router-dom";

const LeadsByTime = ({
                            data
                        }) => {



    const dateOptions = {
        title: {
            text: 'Leads By Day'
        },
        tooltip: {
            trigger: 'axis'
        },
        toolbox: {
            feature: {
                saveAsImage: {}
            }
        },
        xAxis: {
            type: 'category',
            data: Object.keys(data.leads_by_day)
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                data: Object.values(data.leads_by_day),
                type: 'line'
            }
        ]
    };

    return (
        <Router>
            <Switch>
                <ReactEcharts
                    option={dateOptions}
                    style={{ width: "600px", height: "300px" }}
                ></ReactEcharts>
            </Switch>
        </Router>
    );
};

export default LeadsByTime;